import React, { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import { VideoScreen } from '../../components/VideoScreen/VideoScreen'
import { Image } from '../../components/Image/Image'
import { getIsLangRu } from '../../store/langSlice'

import styles from './VideoWin.module.scss'
import srcVideo from './video-23.mp4'
import srcVideoRu from './video-23-ru.webm'
import srcVideoTt from './video-23-tt.webm'
import srcAudio from './audio-23.mp3'
import congratulationsRu from './congratulations-ru.png'
import congratulationsTt from './congratulations-tt.png'


/* eslint react/prop-types: ["off"] */
export function VideoWinBody({ isVisible, isLangRu }) {
    const [imgShown, setImgShown] = useState(false)

    const onTimeUpdateHandler = useCallback((videoEl) => {
        if (imgShown || videoEl.currentTime < 4) {
            return
        }

        setImgShown(true)
    }, [imgShown, setImgShown])

    return (
        <>
            <div className={styles.textWrapper}>
                <Image
                    src={isLangRu ? congratulationsRu : congratulationsTt}
                    className={classNames(styles.text, { [styles.visible]: imgShown })}
                />
            </div>

            <VideoScreen
                isVisible={isVisible}
                srcVideo={srcVideo}
                srcVideoRu={srcVideoRu}
                srcVideoTt={srcVideoTt}
                srcAudioRu={srcAudio}
                srcAudioTt={srcAudio}
                onTimeUpdate={onTimeUpdateHandler}
            />
        </>
    )
}

const VideoWin = connect(
    state => ({
        isLangRu: getIsLangRu(state),
    }),
)(VideoWinBody)

VideoWin.propTypes = {}

export { VideoWin }
